import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkle, ArrowRight, X } from "@phosphor-icons/react";

export const WHATS_NEW_KEY = "firewatch:whats_new_seen:2026-fall";

export default function WhatsNewBanner() {
  const [show, setShow] = useState(() => !localStorage.getItem(WHATS_NEW_KEY));
  if (!show) return null;
  const dismiss = () => {
    localStorage.setItem(WHATS_NEW_KEY, "1");
    setShow(false);
  };
  return (
    <div
      data-testid="whats-new-banner"
      className="shrink-0 flex items-center gap-3 px-3 sm:px-4 py-2 bg-tac-primary/15 border-b border-tac-primary/50 text-tac-text animate-in fade-in slide-in-from-top-1"
    >
      <Sparkle size={16} weight="fill" className="text-tac-primary shrink-0" />
      <div className="min-w-0 flex-1 text-[13px] leading-snug truncate sm:whitespace-normal">
        <span className="font-bold uppercase tracking-wider text-tac-primary text-[11px] mr-2">New this season</span>
        Prescribed-burn units &amp; Burning Today, flood and debris-flow watch, quiet hours, Google sign-in, and narrated video walkthroughs in English &amp; Español.{" "}
        <Link to="/whats-new" onClick={dismiss} data-testid="whats-new-changelog-link" className="text-tac-primary hover:underline whitespace-nowrap">Full changelog</Link>
      </div>
      <Link
        to="/about"
        onClick={dismiss}
        data-testid="whats-new-link"
        className="shrink-0 inline-flex items-center gap-1 px-2.5 py-1 bg-tac-primary text-black text-[11px] font-bold uppercase tracking-wider rounded-sm hover:opacity-90 transition-opacity"
      >
        See what's new <ArrowRight size={12} weight="bold" />
      </Link>
      <button
        type="button"
        onClick={dismiss}
        data-testid="whats-new-dismiss"
        aria-label="Dismiss"
        className="shrink-0 text-tac-faint hover:text-tac-text transition-colors"
      >
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
